import React from 'react';
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import { formatDateTime } from '../../../shared/utils/date';
import SmallLoader from '../../../components/SmallLoader';
import { formatEmc, formatSupplier } from '../../../shared/utils/run';
import { Link } from 'react-router';

const manifestNumberFormatter = manifest => {
    if (manifest.manifestId) {
        return (
            <div>
                <p key={manifest.manifestId}>
                    <Link to={`manifests/${manifest.manifestId}`}>{manifest.manifestNumber}</Link>
                </p>
            </div>
        );
    }
};

class SpecialManifestsInfo extends React.Component {
    render() {
        const { abnormalityManifests, showNumberOfPallets = false } = this.props;

        if (!abnormalityManifests) {
            return (
                <div className="text-center">
                    <SmallLoader />
                </div>
            );
        }

        return (
            <div>
                <BootstrapTable data={abnormalityManifests} hover>
                    <TableHeaderColumn
                        dataField="manifest"
                        dataFormat={manifest => manifest.manifestId}
                        isKey
                        hidden
                    >
                        Manifest ID
                    </TableHeaderColumn>
                    <TableHeaderColumn
                        dataField="manifest"
                        dataFormat={manifest => manifestNumberFormatter(manifest)}
                        dataSort
                    >
                        Manifest
                    </TableHeaderColumn>
                    <TableHeaderColumn
                        dataField="manifest"
                        dataFormat={manifest =>
                            formatSupplier({
                                supplierCode: manifest.supplierCode,
                                supplierPlantCode: manifest.supplierPlantCode,
                            })
                        }
                    >
                        Supplier
                    </TableHeaderColumn>
                    <TableHeaderColumn
                        dataField="manifest"
                        dataFormat={manifest =>
                            formatEmc({
                                emcCode: manifest.emcCode,
                                emcPlantCode: manifest.emcPlantCode,
                            })
                        }
                    >
                        EMC
                    </TableHeaderColumn>
                    <TableHeaderColumn
                        dataField="manifest"
                        dataFormat={manifest => manifest.emcDockCode}
                    >
                        Dock
                    </TableHeaderColumn>
                    <TableHeaderColumn
                        dataField={showNumberOfPallets ? 'numberOfPallets' : 'totalPallets'}
                    >
                        Impacted # of pallets
                    </TableHeaderColumn>
                    <TableHeaderColumn
                        dataField="manifest"
                        dataFormat={manifest => formatDateTime(manifest.pLaneExit)}
                    >
                        P-Lane exit
                    </TableHeaderColumn>
                </BootstrapTable>
            </div>
        );
    }
}

export default SpecialManifestsInfo;
